export const messages = {
  en: {
    contractChangeAuditOrders: {
      title: 'Change To-do List',
      contractCode: 'Contract Number',
      contractName: 'Contract Name',
      contractType: 'Contract Type',
      contractStatus: 'Contract Status',
      createTime: 'Create Time',
      operation: 'Operation',
      view: 'View',
      audit: 'Audit',
      finish: 'Finish',
      processEnd: 'Process End',
      page: {
        subtitle: 'Review contract change applications and approvals',
        empty: 'No pending change orders found',
        loadFailed: 'Failed to load change to-do list'
      }
    },
  },
  zh: {
    contractChangeAuditOrders: {
      title: '变更待办单',
      contractCode: '合同编号',
      contractName: '合同名称',
      contractType: '合同类型',
      contractStatus: '合同状态',
      createTime: '创建时间',
      operation: '操作',
      view: '查看',
      audit: '审批',
      finish: '结束',
      processEnd: '处理结束',
      page: {
        subtitle: '审核合同变更申请与审批',
        empty: '暂无待办变更单',
        loadFailed: '获取变更待办列表失败'
      }
    },
  }
}